/**
 * Generate Study Dialog - Validation Schemas
 *
 * Migrated from: lego/page/etmf/overview/generate-study/Validation.jsx
 *
 * Yup validation schemas for each step of the wizard
 */

import * as yup from 'yup'

export const ValidationSchema = (currentStep: number) => {
  yup.setLocale({
    mixed: {
      required: 'GENERAL_FORM_FIELD_IS_REQUIRED_ERROR'
    },
    string: {
      max: 'FORM_VALIDATION_ERROR_MAX_LENGTH_IS_${max}'
    }
  })

  const schema = yup.object().shape({
    product:
      currentStep < 2
        ? yup.string().nullable()
        : yup.string().nullable().required('GENERATE_STUDY_PRODUCT_IS_REQUIRED'),

    study:
      currentStep < 3 ? yup.string().nullable() : yup.string().nullable().required('GENERATE_STUDY_STUDY_IS_REQUIRED'),

    environment:
      currentStep < 4
        ? yup.string().nullable()
        : yup.string().nullable().required('GENERATE_STUDY_ENVIRONMENT_IS_REQUIRED'),

    countries: yup.lazy(() => {
      return currentStep < 5 ? yup.array().nullable() : yup.array()
    }),

    sites: yup.lazy(() => {
      return currentStep < 6 ? yup.array().nullable() : yup.array()
    })
  })

  return schema
}

export default ValidationSchema
